/* LOCATION / CURRENCY */

window.onload = function () {
  const links = document.querySelectorAll(".select-location-link");

  links.forEach((link) => {
    link.addEventListener("click", function handleClick(event) {
      var subdom = link.getAttribute("data-subdom");
      var path = document.location.pathname;
      var host = location.hostname;
      if (host.charAt(2) == ".") {
        var host = host.slice(3); // remove existing region subdomain
      }
      path = path.replace("en-ca/", ""); // remove ca if present
      if (subdom == "us") {
        var dest = "https://" + host + path;
      } else {
        var dest = "https://" + subdom + "." + host + path;
      }
      //alert("host = " + host_nosubdom + "\nsubdom = " + subdom + "\n" + dest);
      window.location.href = dest;
      e.preventDefault();
    });
  });
};

/* END LOCATION / CURRENCY */
